import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";

const KEY = "sb_age_ok";

export default function AgeGate() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const ok = localStorage.getItem(KEY);
    if (!ok) {
      setOpen(true);
      document.body.style.overflow = "hidden";
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "1");
    setOpen(false);
    document.body.style.overflow = "";
  };

  const reject = () => {
    window.location.href = "https://www.begambleaware.org/";
  };

  if (!open) return null;

  return (
    <div
      data-testid="age-gate-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center p-6"
      style={{ background: "rgba(6,10,6,0.95)", backdropFilter: "blur(20px)" }}
    >
      <div className="max-w-md w-full sb-card p-8 rounded-lg sb-fade-up">
        <div className="flex flex-col items-center text-center gap-5">
          <div
            className="w-14 h-14 rounded-full flex items-center justify-center"
            style={{ background: "rgba(255,179,0,0.12)", border: "1px solid rgba(255,179,0,0.4)" }}
          >
            <AlertTriangle size={28} color="#FFB300" />
          </div>
          <div className="space-y-2">
            <h2 className="font-display text-3xl font-black">Are you over 18?</h2>
            <p className="text-sm" style={{ color: "var(--sb-text-secondary)" }}>
              This site contains gambling-related content and affiliate links to UK licensed
              bookmakers. You must be 18 or over to enter.
            </p>
          </div>
          <div className="flex flex-col w-full gap-3 mt-2">
            <button
              data-testid="age-gate-yes"
              onClick={accept}
              className="sb-btn-primary py-3 text-sm uppercase tracking-wider"
            >
              Yes, I am 18 or over
            </button>
            <button
              data-testid="age-gate-no"
              onClick={reject}
              className="sb-btn-outline py-3 text-sm uppercase tracking-wider"
              style={{ borderColor: "rgba(255,59,48,0.5)", color: "#FF6B61" }}
            >
              No, take me to BeGambleAware
            </button>
          </div>
          <p className="text-[10px] uppercase tracking-wider" style={{ color: "var(--sb-text-muted)" }}>
            18+ · BeGambleAware.org · GamCare
          </p>
        </div>
      </div>
    </div>
  );
}
